






















import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
import {Component, Emit, Prop} from "vue-property-decorator";
import PlanningEntryCreate from "../../models/planningEntry/PlanningEntryCreate";
import CompanyAutocompleteInput from "@/components/company/CompanyAutocompleteInput.vue";
import AsiDatePicker from "@/components/common/AsiDatePicker.vue";
import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
import OrderSimple from "@/models/order/OrderSimple";
import UserAutocompleteInput from "@/components/user/UserAutocompleteInput.vue";
import AsiTextField from "@/components/common/AsiTextField";
import OrderAutocompleteInput from "@/components/order/OrderAutocompleteInput.vue";
import {AxiosError} from "axios";
import UserSimple from "@/models/user/UserSimple";
import AsiTextarea from "@/components/common/AsiTextarea";
import UserListFilter from "@/models/user/UserListFilter";
import {CompanyType} from "@/helpers/constants";
import OrderListFilter from "@/models/order/OrderListFilter";

@Component({
	components: {
		AsiTextarea,
		OrderAutocompleteInput,
		AsiTextField, UserAutocompleteInput, AsiDialogFormLayout, AsiDatePicker, CompanyAutocompleteInput
	}
})
export default class PlanningEntryCreateDialog extends AsiDialogForm {

	@Prop({type: Object, default: null})
	public order!: OrderSimple | null;

	@Prop({type: String, default: null})
	public date!: string | null;

	@Prop({type: Object, default: null})
	public user!: UserSimple | null;

	protected model: PlanningEntryCreate = new PlanningEntryCreate();

	private get orderListFilter(): OrderListFilter {
		const filter = new OrderListFilter();
		if (this.date) {
			filter.dateFrom = this.date;
			filter.dateTo = this.date;
		}
		return filter;
	}

	private get userListFilter(): UserListFilter {
		const filter = new UserListFilter();
		filter.companyTypes = [CompanyType.internal];
		return filter;
	}

	private get minDate(): string | null {
		return this.order !== null ? this.order.dateFrom : null;
	}

	private get maxDate(): string | null {
		return this.order !== null ? this.order.dateTo : null;
	}

	public mounted(): void {
		this.initialize();
	}

	@Emit('save')
	public save(event: Event): Event {
		this.initialize();
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		const form = this.$refs.form as HTMLFormElement;
		this.reset([this.model], form);
		this.initialize();
		return event;
	}

	private initialize(): void {
		const form = this.$refs.form as HTMLFormElement;
		this.reset([this.model], form);
		if (this.order) {
			this.model.orderId = this.order.id;
		}
		if (this.user) {
			this.model.userId = this.user.id;
		}
		if (this.date) {
			this.model.date = this.date;
		}
	}

	private requestSave(event: Event): void {
		if (this.model.orderId === null) return;

		this.loading = true;
		this.$orderService.createPlanningEntry(this.model.orderId, this.model)
			.then(() => {
				this.save(event);
			})
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
